export default {
  // Hero Section
  'hero.badge': 'Werde Teil der digitalen Sport-Revolution',
  'hero.title': 'SuperOne Leader & Affiliate Partner',
  'hero.subtitle': 'Starte international als einer der Ersten',
  'hero.intro1': 'Digital Sports ist unsere Plattform für innovative Projekte im digitalen Sportbereich.',
  'hero.intro2': 'Das zentrale Unternehmen, um das es hier geht, ist SuperOne – ein globaler Vorreiter im digitalen Fan-Engagement.',
  'hero.leaderDeal.title': 'Exklusiv für Leader',
  'hero.leaderDeal.desc1': 'Du bist erfahrener Leader und suchst nach einem außergewöhnlichen Deal?',
  'hero.leaderDeal.desc2': 'Unter bestimmten Voraussetzungen bieten wir individuelle Vereinbarungen für Top-Leader mit nachweislicher Erfahrung und starkem Netzwerk. Lass uns über deine Möglichkeiten sprechen!',
  'hero.leaderDeal.feature1': 'Individuelle Konditionen',
  'hero.leaderDeal.feature2': 'Exklusive Territorien',
  'hero.leaderDeal.feature3': 'Direkter CEO-Kontakt',
  'hero.note': '👉 Auf dieser Seite geht es konkret um die Möglichkeit, als Leader oder Affiliate Partner für SuperOne international zu starten.',
  'hero.button': 'Jetzt bewerben',
  
  // Digital Sports x SuperOne
  'digitalSports.title': 'Digital Sports x SuperOne',
  'digitalSports.desc1': 'Digital Sports vernetzt Sport, Community und technologische Innovation.',
  'digitalSports.desc2': 'SuperOne ist das Unternehmen, das wir international beim Wachstum unterstützen.',
  'digitalSports.looking': 'Wir suchen Leader und Affiliate Partner',
  'digitalSports.lookingDesc': 'die ihre Märkte als erste aufbauen und die Expansion von SuperOne aktiv begleiten.',
  
  // Video Section
  'video.badge': 'Video-Präsentation',
  'video.title': 'Die Vision von SuperOne vom CEO',
  'video.ceo': 'Andreas Christensen',
  'video.subtitle': 'vorgestellt',
  'video.note': 'Das Video startet automatisch stumm geschaltet. Du kannst den Ton jederzeit aktivieren.',
  
  // Your Chance
  'chance.title': 'Deine Chance:',
  'chance.titleHighlight': 'Einer der Ersten',
  'chance.titleSuffix': 'in deinem Land',
  'chance.feature1.title': 'Erste offizielle Partner',
  'chance.feature1.desc': 'In deinem Land zu den allerersten offiziellen Partnern gehören',
  'chance.feature2.title': 'Eigenes Team aufbauen',
  'chance.feature2.desc': 'Ein eigenes Team oder Netzwerk aufbauen und führen',
  'chance.feature3.title': 'Globale Expansion',
  'chance.feature3.desc': 'Langfristig von der globalen Expansion profitieren',
  'chance.note': 'Gerade Leader können früh in ihrer Region Strukturen aufbauen, bevor der Massenmarkt erreicht ist.',
  
  // 100% Serious
  'serious.title': '100 % seriös',
  'serious.subtitle': 'Echtes Unternehmen, echte Wertschöpfung',
  'serious.feature1.title': 'Echtes Produkt',
  'serious.feature1.desc': 'Funktionierendes Gaming-Ökosystem',
  'serious.feature2.title': 'Klare Wertschöpfung',
  'serious.feature2.desc': 'Reale Umsätze & Geschäftsmodell',
  'serious.feature3.title': 'CEO Updates',
  'serious.feature3.desc': 'Regelmäßiger Austausch',
  'serious.feature4.title': 'Nachweisbar',
  'serious.feature4.desc': 'Transparente Unternehmensstruktur',
  'serious.conclusion': 'Als Leader oder Affiliate Partner profitierst du von vollem Zugang zu Informationen, Meetings und strategischen Insights.',
  
  // Game Live
  'gameLive.badge': 'Jetzt Live Verfügbar',
  'gameLive.title': 'SuperOne ist',
  'gameLive.titleHighlight': 'live',
  'gameLive.titleSuffix': 'im App Store & Google Play',
  'gameLive.subtitle': 'Das Spiel ist bereits verfügbar und Millionen von Spielern weltweit können es herunterladen',
  'gameLive.principle': 'Das Spielprinzip',
  'gameLive.quiz.title': 'Fußball Quiz',
  'gameLive.quiz.desc': 'Ein spannendes Fußball-Quiz-Game, bei dem Spieler ihr Wissen testen',
  'gameLive.battleRoyale.title': 'Battle Royale Format',
  'gameLive.battleRoyale.desc': 'Spieler treten in einem Battle Royale gegeneinander an – nur die Besten gewinnen',
  'gameLive.prizes.title': 'Echte Geldpreise',
  'gameLive.prizes.desc': 'Spieler können reale Geldpreise gewinnen – keine virtuellen Währungen',
  'gameLive.prizePool': 'Tages- & Wochensieger',
  'gameLive.prizePoolDesc': 'Regelmäßige Gewinnchancen',
  'gameLive.businessModel': 'Das Geschäftsmodell – Echte Wertschöpfung',
  'gameLive.step1.title': '10 Spiele kostenlos',
  'gameLive.step1.desc': 'Jeder Spieler kann täglich 10 Spiele kostenlos spielen',
  'gameLive.step2.title': 'GamePass für $1',
  'gameLive.step2.desc': 'Für nur $1 können Spieler unbegrenzt weiterspielen',
  'gameLive.step3.title': 'Echte Umsätze',
  'gameLive.step3.desc': 'Wertschöpfung durch GamePass-Käufe, nicht durch Einzahlungen',
  'gameLive.conclusion': 'SuperOne basiert auf echten digitalen Umsätzen – ein nachhaltiges und transparentes Geschäftsmodell',
  
  // Why Now
  'whyNow.badge': 'Perfektes Timing',
  'whyNow.title': 'Warum gerade',
  'whyNow.titleHighlight': 'jetzt',
  'whyNow.subtitle': 'SuperOne steht unmittelbar vor einem weltweiten Durchbruch',
  'whyNow.feature1.title': 'Großer Rollout',
  'whyNow.feature1.desc': 'Weltweiter Rollout in den nächsten Wochen',
  'whyNow.feature2.title': 'Medien-Präsenz',
  'whyNow.feature2.desc': 'Präsenz in Medien & Social Media',
  'whyNow.feature3.title': 'Internationale Stars',
  'whyNow.feature3.desc': 'Stars mit bis zu 250 Mio. Followern starten Kampagnen',
  'whyNow.conclusion': 'Für Leader und Affiliate Partner entsteht dadurch ein außergewöhnlicher Timing-Vorteil.',
  
  // Compensation Model
  'compensation.title': 'Das Vergütungsmodell –',
  'compensation.titleHighlight': 'klar und attraktiv',
  'compensation.system': 'Unilevel Affiliate System',
  'compensation.level1': 'Direkte Partner',
  'compensation.level1Desc': 'Auf Ebene 1',
  'compensation.levels': 'Ebenen 2–10',
  'compensation.levelsDesc': 'Je nach Qualifikation',
  'compensation.note': 'Leader profitieren besonders stark, da sie größere Teams aufbauen und strategisch führen können.',
  
  // Fan Calculator
  'calculator.badge': 'Einnahmenpotenzial',
  'calculator.title': 'Dein',
  'calculator.titleHighlight': 'Einnahmenpotenzial',
  'calculator.titleSuffix': 'in 12 Monaten',
  'calculator.subtitle': 'Realistische Berechnungen basierend auf einem Pro Fanpack für $500 (einmalig)',
  'calculator.scenario1': 'Szenario 1: Viralität von 2',
  'calculator.scenario2': 'Szenario 2: Viralität von 2.5',
  'calculator.conservative': 'Konservatives Szenario',
  'calculator.realistic': 'Realistisches Szenario',
  'calculator.investment': 'Einmalige Investition',
  'calculator.investmentDesc': '1 Pro Fanpack für $500 (einmalig)',
  'calculator.virality2': 'Viralität von 2',
  'calculator.virality2Desc': 'Jeder Spieler gibt das Spiel an 2 weitere Personen pro Monat weiter',
  'calculator.virality25': 'Viralität von 2.5',
  'calculator.virality25Desc': 'Jeder Spieler gibt das Spiel an 2.5 weitere Personen pro Monat weiter',
  'calculator.annualRewards': 'Jährliche Belohnungen',
  'calculator.activeFans': 'Active Fans',
  'calculator.monetizedFans': 'Monetized Fans',
  'calculator.afterMonths': 'nach 12 Monaten',
  'calculator.ofFans': '20% der Fans',
  'calculator.currentBetter': 'Aktuell sogar noch besser!',
  'calculator.currentBetterDesc1': 'Die Berechnungen basieren auf einer Viralität von 2 bis 2.5 (konservativ bis realistisch).',
  'calculator.currentBetterDesc2': 'Aktuell liegt die durchschnittliche Viralität bei 6! Das bedeutet, dass die tatsächlichen Einnahmen deutlich höher ausfallen können.',
  'calculator.comparison': 'Vergleich der Szenarien',
  'calculator.metric': 'Metrik',
  'calculator.annualRewardsMetric': 'Jährliche Belohnungen',
  'calculator.activeFansMetric': 'Active Fans',
  'calculator.monetizedFansMetric': 'Monetized Fans',
  'calculator.probability': 'Wahrscheinlichkeit',
  'calculator.veryConservative': 'Sehr konservativ',
  'calculator.realisticProb': 'Realistisch (50%)',
  'calculator.currentAverage': 'Aktueller Durchschnitt',
  'calculator.exponentialGrowth': 'Exponentielles Wachstum',
  'calculator.exponentialGrowthDesc': 'Durch Viralität wächst dein Netzwerk exponentiell',
  'calculator.probability50': '50% Wahrscheinlichkeit',
  'calculator.probability50Desc': 'Konservative Berechnung mit realistischen Annahmen',
  'calculator.arpu': 'ARPU $100',
  'calculator.arpuDesc': 'Durchschnittlicher Umsatz pro monetarisiertem Fan',
  'calculator.cta.title': 'Starte jetzt als Leader oder Affiliate Partner',
  'calculator.cta.desc': 'Mit nur $500 einmalig kannst du ein passives Einkommen aufbauen, das exponentiell wächst',
  'calculator.cta.button': 'Jetzt bewerben',
  
  // USP 1
  'usp1.badge': 'USP #1',
  'usp1.title': 'Echtzeit-Provisionen in',
  'usp1.titleHighlight': 'Krypto',
  'usp1.feature1': 'Echtzeit',
  'usp1.feature1Desc': 'Sofortige Auszahlung',
  'usp1.feature2': 'Direkt ins Wallet',
  'usp1.feature2Desc': 'Auf dein eigenes Wallet',
  'usp1.feature3': 'Transparent',
  'usp1.feature3Desc': 'Nachvollziehbar & sicher',
  'usp1.conclusion': 'Ideal für Leader und Affiliates, die schnelle und transparente Vergütung schätzen.',
  
  // USP 2
  'usp2.badge': 'USP #2',
  'usp2.title': 'Gamer kaufen &',
  'usp2.titleHighlight': 'Netzwerk ausbauen',
  'usp2.subtitle': 'SuperOne bietet allen Partnern ein besonderes Wachstumstool',
  'usp2.step1': 'Gamer kaufen',
  'usp2.step1Desc': 'Gamer können aktiv gekauft werden',
  'usp2.step2': 'Automatisch Ebene 1',
  'usp2.step2Desc': 'Sie landen automatisch in Ebene 1',
  'usp2.step3': 'Partner werden',
  'usp2.step3Desc': 'Aus Gamern können später Partner entstehen',
  'usp2.conclusion.title': 'Leader profitieren stark',
  'usp2.conclusion.desc': 'Dieses Modell beschleunigt sowohl Teamaufbau als auch Einnahmen',
  
  // Support
  'support.title': 'Unterstützung &',
  'support.titleHighlight': 'Zusammenarbeit',
  'support.subtitle': 'Als Leader oder Affiliate Partner erhältst du umfassenden Support',
  'support.feature1': 'Individuelle Zoom-Calls',
  'support.feature2': 'Teamaufbau-Strategien',
  'support.feature3': 'Weekly Town Halls',
  'support.feature4': 'Promotions & Incentives',
  'support.feature5': 'Offline-Events',
  'support.feature6': 'Leader Deals',
  
  // Who is it for
  'whoFor.title': 'Für wen eignet sich',
  'whoFor.titleHighlight': 'SuperOne',
  'whoFor.feature1': 'Erfahrene Leader, die Teams aufbauen möchten',
  'whoFor.feature2': 'Affiliate Partner, die international skalieren wollen',
  'whoFor.feature3': 'Personen mit Netzwerk im Sport, Online-Marketing oder Social Media',
  'whoFor.feature4': 'Unternehmer, Influencer, Agenten und Community-Builder',
  'whoFor.feature5': 'Alle, die früh in ein global wachsendes System einsteigen wollen',
  
  // Application Form
  'form.title': 'Nächste',
  'form.titleHighlight': 'Schritte',
  'form.subtitle': 'Wenn du als Leader oder Affiliate Partner starten möchtest',
  'form.step1': 'Formular ausfüllen',
  'form.step1Desc': 'Kurze Bewerbung',
  'form.step2': 'Persönliches Gespräch',
  'form.step2Desc': 'Kennenlernen & Fragen',
  'form.step3': 'Onboarding & Start',
  'form.step3Desc': 'Sofort loslegen',
  'form.thankYou': 'Vielen Dank für deine Bewerbung!',
  'form.thankYouDesc': 'Wir haben deine Bewerbung erhalten und werden uns innerhalb von 24 Stunden bei dir melden.',
  'form.checkSpam': 'Bitte überprüfe auch deinen Spam-Ordner',
  'form.name': 'Vollständiger Name',
  'form.email': 'E-Mail-Adresse',
  'form.phone': 'Telefonnummer',
  'form.country': 'Land',
  'form.role': 'Gewünschte Rolle',
  'form.roleSelect': 'Bitte wählen',
  'form.roleLeader': 'Leader',
  'form.roleAffiliate': 'Affiliate Partner',
  'form.roleBoth': 'Beides möglich',
  'form.experience': 'Erfahrung im Network Marketing',
  'form.experienceNone': 'Keine Erfahrung',
  'form.experienceLittle': 'Wenig Erfahrung (1-2 Jahre)',
  'form.experienceMedium': 'Mittlere Erfahrung (3-5 Jahre)',
  'form.experienceMuch': 'Viel Erfahrung (5+ Jahre)',
  'form.experiencePro': 'Profi / Top Leader',
  'form.socialMedia': 'Social Media Kanäle',
  'form.socialMediaDesc': 'Gib deine Social Media Kanäle mit Links und Reichweite an',
  'form.instagram': 'Instagram',
  'form.instagramPlaceholder': 'z.B. @username - 10.000 Follower',
  'form.facebook': 'Facebook',
  'form.facebookPlaceholder': 'z.B. facebook.com/username - 5.000 Freunde',
  'form.tiktok': 'TikTok',
  'form.tiktokPlaceholder': 'z.B. @username - 50.000 Follower',
  'form.youtube': 'YouTube',
  'form.youtubePlaceholder': 'z.B. youtube.com/@channel - 20.000 Abonnenten',
  'form.linkedin': 'LinkedIn',
  'form.linkedinPlaceholder': 'z.B. linkedin.com/in/username - 3.000 Kontakte',
  'form.other': 'Andere Kanäle',
  'form.otherPlaceholder': 'z.B. Twitter, Telegram, etc.',
  'form.startBudget': 'Startbudget',
  'form.startBudgetDesc': 'Wie hoch ist dein geplantes Startbudget?',
  'form.budget500': '$500',
  'form.budget5000': '$5.000',
  'form.budget10000': '$10.000',
  'form.budgetMore': 'Mehr als $10.000',
  'form.message': 'Warum möchtest du SuperOne Partner werden?',
  'form.messagePlaceholder': 'Erzähle uns von deinen Zielen und deiner Motivation...',
  'form.whatHappens': 'Was passiert nach der Bewerbung?',
  'form.whatHappens1': 'Wir prüfen deine Bewerbung innerhalb von 24 Stunden',
  'form.whatHappens2': 'Du erhältst eine Einladung zu einem persönlichen Gespräch',
  'form.whatHappens3': 'Bei Eignung: Sofortiges Onboarding und Start möglich',
  'form.submit': 'Bewerbung absenden',
  'form.submitting': 'Wird gesendet...',
};